<template>
    <div>
        <div class="popup_st04">
            <div :class="classPrefix + 'popup_wrap'">
                <div class="title"><span class="t02">{{ dongAirInfo.hjdNm }}</span></div>
                <div class="text">
                    <span class="pop_bt_state green">{{ dongAirInfo.airTypeNm }}</span>
                    <span> {{ formatDate(dongAirInfo.measureTime) }} 기준</span>
                </div>
                <div class="air_box">
                    <ul>
                        <li>
                            <p class="txt01">{{ dongAirInfo.hjdNm }}</p>
                            <p :class="['txt02', typeof dongAirInfo.level !== $_TYPE.UNDEF ? dongAirInfo.level[4] : '']">
                                {{ typeof dongAirInfo.level !== $_TYPE.UNDEF ? dongAirInfo.val : '' }}
                            </p>
                            <p class="txt03">{{ dongAirInfo.unit }}</p>
                        </li>
                        <li v-show="['pm10','pm25','o3','no2'].includes(dongAirInfo.airType)">
                            <p class="txt01">서울시 평균</p>
                            <p :class="['txt02', typeof airSggAvg[airType + 'Level'] !== $_TYPE.UNDEF ? airSggAvg[airType + 'Level'][4] : '']">
                                {{ !isNaN(airSggAvg[airType]) ? airSggAvg[airType] :  '-'}}
                            </p>
                            <p class="txt03">{{ dongAirInfo.unit }}</p>
                        </li>
                        <li v-show="['decibel'].includes(dongAirInfo.airType)">
                            <p class="txt01">강남구 평균</p>
                            <p :class="['txt02', typeof airSensorLevel[0] !== $_TYPE.UNDEF ? airSensorLevel[4] : '']">
                                {{ !isNaN(airSensorLevel[2]) ? airSensorLevel[2] :  '-'}}
                            </p>
                            <p class="txt03">{{ dongAirInfo.unit }}</p>
                        </li>
                    </ul>
                </div>
                <div class="pop_bt_close2"><a href="javascript: void(0);" class="self-close-btn">닫기</a></div>
            </div>
        </div>
    </div>
</template>

<script>
import { $_TYPE } from '@/confs/common.const';
import {mapGetters} from "vuex";
import gripUtil from "@/libs/grip.util";
import airLevel from "@/libs/air.level.js";

export default {
    props: {
        classPrefix: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            dongAirInfo: {},
            measureTime: '',
            airSensorLevel: [],
        };
    },

    computed: {
        ...mapGetters({
            airHjdSensorList: 'getAirHjdSensorList',
            airSggList: 'getAirSggList',
        }),

        airType() {
            return this.dongAirInfo.airType;
        },

        airSggAvg() {
            let airSggList = this.airSggList;
            let total = {pm10: 0, pm10Cnt: 0, pm25: 0, pm25Cnt: 0, no2: 0, no2Cnt: 0, o3: 0, o3Cnt: 0};
            let avg = {pm10: 0, pm10Level: ['', ''], pm25: 0, pm25Level: ['', ''], no2: 0, ne2Level: ['', ''], o3: 0, o3Level: ['', '']};


            if(typeof airSggList !== $_TYPE.UNDEF) {
                airSggList.forEach((airSgg)=>{
                    // 미세먼지
                    if(!isNaN(airSgg.val3)) {
                        total.pm10 += Number(airSgg.val3);
                        total.pm10Cnt += 1;
                    }

                    // 초미세먼지
                    if(!isNaN(airSgg.val4)) {
                        total.pm25 += Number(airSgg.val4);
                        total.pm25Cnt += 1;
                    }

                    // 이산화질소
                    if(!isNaN(airSgg.val8)) {
                        total.no2 += Number(airSgg.val8);
                        total.no2Cnt += 1;
                    }

                    // 오존
                    if(!isNaN(airSgg.val6)) {
                        total.o3 += Number(airSgg.val6);
                        total.o3Cnt += 1;
                    }
                });
            }

            avg.pm10 = (total.pm10 / total.pm10Cnt).toFixed(0);
            avg.pm10Level = airLevel.pm10Level(avg.pm10);
            avg.pm25 = (total.pm25 / total.pm25Cnt).toFixed(0);
            avg.pm25Level = airLevel.pm25Level(avg.pm25);
            avg.no2 = (total.no2 / total.no2Cnt).toFixed(2);
            avg.no2Level = airLevel.no2Level(avg.no2);
            avg.o3 = (total.o3 / total.o3Cnt).toFixed(3);
            avg.o3Level = airLevel.o3Level(avg.o3);
            
            return avg;
        },
    },

    updated() {
        if(typeof this.dongAirInfo.hjdNm !== $_TYPE.UNDEF) {
            this.$emit('loaded-air-info', this.$el.innerHTML);
        }
    },

    methods: {
        setDongAirInfo(dongAirInfo) {
            if(this.measureTime != dongAirInfo.measureTime) {
                this.$store.dispatch('FETCH_AIR_SGG_LIST');
                this.measureTime = dongAirInfo.measureTime;
            }
            this.airSensorLevel = this.getAirSensorLevel(dongAirInfo.airType);
            this.dongAirInfo = Object.assign({}, dongAirInfo);
        },

        formatDate(val) {
            if(typeof val !== $_TYPE.UNDEF && val.length >= 12) {
                return gripUtil.formatDate(val, 'yyyy-MM-dd HH:mm');
            }
            return "";
        },
        getAirSensorLevel(sensorCode){
            let sensorCount = 0;
            let sensorSum = 0;

            if(sensorCode === 'pm10'){
                this.airHjdSensorList.forEach((air)=>{
                    if(!isNaN(air.fineDustAvg)) {
                        sensorCount++;
                        sensorSum += Number(air.fineDustAvg);
                    }
                });
                return airLevel.pm10Level(sensorSum / sensorCount);
            }else if(sensorCode === 'pm25'){
                this.airHjdSensorList.forEach((air)=>{
                    if(!isNaN(air.ultraFineDustAvg)) {
                        sensorCount++;
                        sensorSum += Number(air.ultraFineDustAvg);
                    }
                });
                return airLevel.pm25Level(sensorSum / sensorCount);
            }else if(sensorCode === 'o3'){
                this.airHjdSensorList.forEach((air)=>{
                    if(!isNaN(air.o3)) {
                        sensorCount++;
                        sensorSum += Number(air.o3);
                    }
                });
                return airLevel.o3Level(sensorSum / sensorCount);
            }else if(sensorCode === 'no2'){
                this.airHjdSensorList.forEach((air)=>{
                    if(!isNaN(air.no2)) {
                        sensorCount++;
                        sensorSum += Number(air.no2);
                    }
                });
                return airLevel.no2Level(sensorSum / sensorCount);
            }else if(sensorCode === 'decibel'){
                this.airHjdSensorList.forEach((air)=>{
                    if(!isNaN(air.decibelAvg)) {
                        sensorCount++;
                        sensorSum += Number(air.decibelAvg);
                    }
                });
                return airLevel.decibelLevel(sensorSum / sensorCount);
            }
        },
    },
}
</script>
